import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src", "alt"]
const _hoisted_2 = { class: "mt-4 grid grid-cols-2 gap-4" }
const _hoisted_3 = { class: "col-span-2" }
const _hoisted_4 = { class: "col-span-2" }
const _hoisted_5 = { class: "col-span-2" }
const _hoisted_6 = { class: "col-span-2" }
const _hoisted_7 = { class: "col-span-2" }


	const __default__ = { name: "BallResultDetails" } // name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
		result: {
			type: Object,
			default: () => {return {}}
		}
	},
  setup(__props) {

const props = __props;

	

return (_ctx: any,_cache: any) => {
  const _component_v_text = _resolveComponent("v-text")!
  const _component_v_strong = _resolveComponent("v-strong")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("img", {
      src: __props.result.ImageUrl,
      alt: __props.result.ProductDisplayText,
      name: "ball-image",
      class: "bg-white rounded object-contain w-full h-[342px]"
    }, null, 8, _hoisted_1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_v_text, { class: "text" }, {
          default: _withCtx(() => [
            _createTextVNode(" Pole 1 ")
          ]),
          _: 1
        }),
        _createVNode(_component_v_strong, { class: "text-lg" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(__props.result.Product), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_v_text, { class: "text" }, {
          default: _withCtx(() => [
            _createTextVNode(" Pole 2 ")
          ]),
          _: 1
        }),
        _createVNode(_component_v_strong, { class: "text-lg" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(__props.result.Pole2), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_v_text, { class: "text" }, {
          default: _withCtx(() => [
            _createTextVNode(" Seam 1 ")
          ]),
          _: 1
        }),
        _createVNode(_component_v_strong, { class: "text-lg" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(__props.result.ProductSecondary), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_v_text, { class: "text" }, {
          default: _withCtx(() => [
            _createTextVNode(" Seam 2 ")
          ]),
          _: 1
        }),
        _createVNode(_component_v_strong, { class: "text-lg" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(__props.result.Seam2), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_v_text, { class: "text" }, {
          default: _withCtx(() => [
            _createTextVNode(" Color ")
          ]),
          _: 1
        }),
        _createVNode(_component_v_strong, { class: "text-lg" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(__props.result.Colour), 1)
          ]),
          _: 1
        })
      ])
    ])
  ], 64))
}
}

})